module.exports = __webpack_public_path__ + "img/twitter.d36beccc.svg";